import * as React from 'react'
import { BlazeButton } from '../../../../components/CustomButtons/BlazeButton'
import { PermissionNames } from '@getgreenline/homi-shared'
import { CurrentUserStore } from '../../../../stores/CurrentUserStore'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { inject } from 'mobx-react'
import { CustomerImportExportModal } from './ImportExport/CustomerImportExportModal'

interface Props {
  showAddCustomerModal: VoidFunction
  loadCustomers: () => Promise<void>
}

interface InjectedProps {
  currentUserStore?: CurrentUserStore
  currentCompanyStore?: CurrentCompanyStore
}

interface State {
  showAddCustomerModal: boolean
  showImportExportModal: boolean
}

@inject('currentUserStore', 'currentCompanyStore')
export class CustomerHeader extends React.Component<Props & InjectedProps, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      showAddCustomerModal: false,
      showImportExportModal: false,
    }
  }

  render() {
    const canAddCustomers = this.props.currentUserStore!.hasPermissionAtEntity(
      PermissionNames.CAN_ADD_CUSTOMERS,
      this.props.currentCompanyStore!.company!.id,
    )

    const { showAddCustomerModal, loadCustomers } = this.props
    const { showImportExportModal } = this.state

    return (
      <>
        <span className='spaced-button-wrapper'>
          <BlazeButton
            buttonProps={{
              icon: 'download',
              onClick: () => this.setState({ showImportExportModal: true }),
            }}
            titleProps={{
              title: 'Import/Export',
            }}
          />

          <BlazeButton
            buttonProps={{
              type: 'primary',
              icon: 'plus',
              onClick: showAddCustomerModal,
              disabled: !canAddCustomers,
            }}
            titleProps={{
              title: 'Add customer',
            }}
          />
        </span>

        <CustomerImportExportModal
          isModalVisible={showImportExportModal}
          closeModal={() => this.setState({ showImportExportModal: false })}
          loadCustomers={loadCustomers}
        />
      </>
    )
  }
}
